import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQueryWithAuth } from '../../fetchBaseQuery';
import { runtimeConfig } from '../../../config/runtimeConfig';
import type { ShopifyDeployRequest, ShopifyDeployResponse } from './types';

/**
 * Ecom is the only service the portal talks to besides MMS, and only for the one thing
 * MMS cannot do: starting a Shopify app deploy
 */
export const ecomConnectorApi = createApi({
  reducerPath: 'ecomConnectorApi',
  baseQuery: fetchBaseQueryWithAuth(runtimeConfig.ecomConnectorApiBaseUrl || ''),
  endpoints: (builder) => ({
    deployShopifyApp: builder.mutation<ShopifyDeployResponse, ShopifyDeployRequest>({
      query: (body) => ({
        url: '/v1/apps/shopify/deploys',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useDeployShopifyAppMutation } = ecomConnectorApi;
